module.exports = __webpack_public_path__ + "static/media/gdp-new.0924d5af.svg";